import { ContactCardBody } from "./SaveContactCard.tsx";
import { useCurrentUserContext } from "../../hooks/useUser.tsx";

/**
 * "Text or email Okthx" card for the Settings → Assistant tab. Surfaces the
 * assistant's phone/email plus a downloadable contact card. Renders nothing
 * until the assistant identity and its vCard URL are available.
 *
 * Previously this lived behind a hamburger-menu dialog (see `ContactCardBody`);
 * it now has a permanent home here.
 */
export const AssistantContactCard = () => {
  const { userContext } = useCurrentUserContext();

  const assistant = userContext?.user?.assistant;
  const vcfUrl = userContext?.user?.assistantVcfUrl;
  // Server-resolved canonical address — authoritative for the displayed email.
  const email = userContext?.user?.assistantCanonicalEmail;
  // Prefer the verified handle over array order, matching the server's own
  // pick when it texts from the assistant (pickAssistantPhoneHandle).
  const phoneHandles = assistant?.handles?.filter((h) => h.type === "phoneNumber") ?? [];
  const phone = (phoneHandles.find((h) => h.verified) ?? phoneHandles[0])?.value;

  if (!assistant || !vcfUrl) return null;

  return (
    <div>
      <h2 className="text-base font-semibold mb-2">Text or email Okthx</h2>
      <p className="text-sm text-muted-foreground mb-4">
        Reach your assistant directly, or save its contact card to your phone.
      </p>
      <div className="max-w-[360px] rounded-2xl border border-border">
        <ContactCardBody phone={phone} email={email} vcfUrl={vcfUrl} />
      </div>
    </div>
  );
};
